/* eslint-disable react/destructuring-assignment */
import React from 'react'

import DropDownItem from '../DropdownItem'
import Dropdown from '../NXDropdown'

class SimpleSelectDropdown extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      showContent: false,
      value: props.value,
    }
    this.showDropdown = this.showDropdown.bind(this)
    this.closeDropdown = this.closeDropdown.bind(this)
    this.onClick = this.onClick.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.showContent !== nextProps.showContent || this.state.value !== nextProps.value) {
      this.setState({
        showContent: nextProps.showContent,
        value: nextProps.value,
      })
    }
  }

  showDropdown() {
    // event.preventDefault();
    this.setState({ showContent: true }, () => {
      document.addEventListener('click', this.closeDropdown)
    })
  }

  onClick(option) {
    this.setState({
      value: option,
    })
    if (this.props.onChange) {
      this.props.onChange(option)
    }
  }

  closeDropdown(event) {
    event.preventDefault()
    if (this.dropdownMenu && !this.dropdownMenu.contains(event.target)) {
      this.setState({ showContent: false }, () => {
        document.removeEventListener('click', this.closeDropdown)
      })
    }
  }

  render() {
    const { options } = this.props
    const { value } = this.state

    return (
      <Dropdown value={value}>
        {options.map((option, index) => (
          // eslint-disable-next-line react/no-array-index-key
          // biome-ignore lint/suspicious/noArrayIndexKey: TODO
          <DropDownItem key={index} onClick={() => this.onClick(option)}>
            {option}
          </DropDownItem>
        ))}
      </Dropdown>
    )
  }
}

SimpleSelectDropdown.defaultProps = {
  options: [],
  showContent: false,
  onChange: () => {},
}

export default SimpleSelectDropdown
